import React from 'react';
import { ROI_ALERT, ONW_ROI_ALERT, DEFAULT_BID_COMPARE, BID_COMPARE_FACTOR } from '../../../../config';
import bid2CompareConfig from '../../../../bid.config';
const redStyle = { background: 'red' };

const Row = (row) => {
    let bid2Compare = bid2CompareConfig[row.country] ? bid2CompareConfig[row.country] : DEFAULT_BID_COMPARE;
    bid2Compare *= BID_COMPARE_FACTOR;

    const bidStyles = row.bid > bid2Compare ? redStyle : {};
    const roiStyles = row.roi < ROI_ALERT ? redStyle : {};
    const onwRoiStyles = row.onwRoi < ONW_ROI_ALERT ? redStyle : {};

    return (
        <tr>
            <td>{row.subid}</td>
            <td>{row.country}</td>
            <td>{row.spent}</td>
            <td>{row.impressions}</td>
            <td>{row.availableClicks}</td>
            <td>{row.clicks}</td>
            <td style={bidStyles}>{row.bid}</td>
            <td>{row.onwRevenue}</td>
            <td>{row.revenue}</td>
            <td>{row.totalRevenue}</td>
            <td style={roiStyles}>{row.roi}</td>
            <td>{row.roiPercent}</td>
            <td style={onwRoiStyles}>{row.onwRoi}</td>
            <td>{row.winRate}</td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/ZeroPark/components/Table/components/Row/index.js